__turbopack_context__.v({
  "activityIndex": "about-module__-i9KWa__activityIndex",
  "activityList": "about-module__-i9KWa__activityList",
  "asideLabel": "about-module__-i9KWa__asideLabel",
  "contact": "about-module__-i9KWa__contact",
  "contactActions": "about-module__-i9KWa__contactActions",
  "content": "about-module__-i9KWa__content",
  "disciplines": "about-module__-i9KWa__disciplines",
  "eyebrow": "about-module__-i9KWa__eyebrow",
  "footer": "about-module__-i9KWa__footer",
  "hero": "about-module__-i9KWa__hero",
  "heroAside": "about-module__-i9KWa__heroAside",
  "heroGrid": "about-module__-i9KWa__heroGrid",
  "heroLead": "about-module__-i9KWa__heroLead",
  "heroTop": "about-module__-i9KWa__heroTop",
  "historyLine": "about-module__-i9KWa__historyLine",
  "introText": "about-module__-i9KWa__introText",
  "location": "about-module__-i9KWa__location",
  "page": "about-module__-i9KWa__page",
  "primaryAction": "about-module__-i9KWa__primaryAction",
  "principles": "about-module__-i9KWa__principles",
  "prose": "about-module__-i9KWa__prose",
  "resourceLinks": "about-module__-i9KWa__resourceLinks",
  "section": "about-module__-i9KWa__section",
  "sectionIntro": "about-module__-i9KWa__sectionIntro",
  "sectionNav": "about-module__-i9KWa__sectionNav",
  "textLink": "about-module__-i9KWa__textLink",
  "toolset": "about-module__-i9KWa__toolset",
});
